import { jsPDF } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';

// Apply the autoTable plugin to jsPDF
applyPlugin(jsPDF);

export const generateProductCataloguePDF = (products) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  
  // Header
  doc.setFillColor(15, 81, 50); // #0F5132
  doc.rect(0, 0, pageWidth, 40, 'F');
  
  // Company Name
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont(undefined, 'bold');
  doc.text('SHIVANGEL', pageWidth / 2, 20, { align: 'center' });
  
  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text('Ayurveda & Nutraceuticals', pageWidth / 2, 28, { align: 'center' });
  doc.text('Product Catalogue 2025', pageWidth / 2, 35, { align: 'center' });
  
  // Contact Info
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(9);
  let yPos = 50;
  doc.text('📞 8950999600 | 8264999600 | 7508009999', pageWidth / 2, yPos, { align: 'center' });
  doc.text('✉ shivangelayurveda.nutra@gmail.com', pageWidth / 2, yPos + 5, { align: 'center' });
  doc.text('🏭 GMP Certified Facility | PAN India Supply', pageWidth / 2, yPos + 10, { align: 'center' });
  
  yPos += 20;
  
  // Group products by category
  const herbalProducts = products.filter(p => p.category === 'Herbal');
  const nutraceuticalProducts = products.filter(p => p.category === 'Nutraceutical');
  
  // Herbal Products Section
  if (herbalProducts.length > 0) {
    doc.setFillColor(15, 81, 50);
    doc.rect(10, yPos, pageWidth - 20, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text(`HERBAL PRODUCTS (${herbalProducts.length})`, 15, yPos + 7);
    
    yPos += 15;
    
    // Group by subcategory
    const herbalBySubcat = {};
    herbalProducts.forEach(p => {
      if (!herbalBySubcat[p.subcategory]) {
        herbalBySubcat[p.subcategory] = [];
      }
      herbalBySubcat[p.subcategory].push(p);
    });
    
    Object.keys(herbalBySubcat).sort().forEach(subcategory => {
      if (yPos > 250) {
        doc.addPage();
        yPos = 20;
      }
      
      doc.setTextColor(15, 81, 50);
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text(`${subcategory} (${herbalBySubcat[subcategory].length})`, 15, yPos);
      yPos += 7;
      
      const tableData = herbalBySubcat[subcategory].map(p => [
        p.name,
        p.packaging_sizes.join(', '),
        p.benefits.substring(0, 80) + '...'
      ]);
      
      doc.autoTable({
        startY: yPos,
        head: [['Product Name', 'Packaging', 'Benefits']],
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: [15, 81, 50], textColor: [255, 255, 255], fontStyle: 'bold' },
        styles: { fontSize: 9, cellPadding: 3 },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 50 },
          2: { cellWidth: 70 }
        },
        margin: { left: 15, right: 15 }
      });
      
      yPos = doc.lastAutoTable.finalY + 10;
    });
  }
  
  // Nutraceutical Products Section
  if (nutraceuticalProducts.length > 0) {
    if (yPos > 200) {
      doc.addPage();
      yPos = 20;
    }
    
    doc.setFillColor(15, 81, 50);
    doc.rect(10, yPos, pageWidth - 20, 10, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text(`NUTRACEUTICAL PRODUCTS (${nutraceuticalProducts.length})`, 15, yPos + 7);
    
    yPos += 15;
    
    const nutraBySubcat = {};
    nutraceuticalProducts.forEach(p => {
      if (!nutraBySubcat[p.subcategory]) {
        nutraBySubcat[p.subcategory] = [];
      }
      nutraBySubcat[p.subcategory].push(p);
    });
    
    Object.keys(nutraBySubcat).sort().forEach(subcategory => {
      if (yPos > 250) {
        doc.addPage();
        yPos = 20;
      }
      
      doc.setTextColor(15, 81, 50);
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text(`${subcategory} (${nutraBySubcat[subcategory].length})`, 15, yPos);
      yPos += 7;
      
      const tableData = nutraBySubcat[subcategory].map(p => [
        p.name,
        p.packaging_sizes.join(', '),
        p.benefits.substring(0, 80) + '...'
      ]);
      
      doc.autoTable({
        startY: yPos,
        head: [['Product Name', 'Packaging', 'Benefits']],
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: [15, 81, 50], textColor: [255, 255, 255], fontStyle: 'bold' },
        styles: { fontSize: 9, cellPadding: 3 },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 50 },
          2: { cellWidth: 70 }
        },
        margin: { left: 15, right: 15 }
      });
      
      yPos = doc.lastAutoTable.finalY + 10;
    });
  }
  
  // Footer on last page
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(128, 128, 128);
    doc.text(
      `Page ${i} of ${totalPages} | Shivangel Ayurveda & Nutraceuticals | GMP Certified`,
      pageWidth / 2,
      doc.internal.pageSize.height - 10,
      { align: 'center' }
    );
  }
  
  // Save
  doc.save('Shivangel-Product-Catalogue-2025.pdf');
};
